import { render, staticRenderFns } from "./UsersAnalysis.vue?vue&type=template&id=4b4edfb7&scoped=true"
import script from "./UsersAnalysis.vue?vue&type=script&lang=js"
export * from "./UsersAnalysis.vue?vue&type=script&lang=js"
import style0 from "./UsersAnalysis.vue?vue&type=style&index=0&id=4b4edfb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4edfb7",
  null
  
)

export default component.exports